import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import NavBar from "./components/NavBar";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Services from "./components/Services";
import Song from "./components/Song";
import Pooja from "./components/Pooja";
import Contact from "./components/Contact";
import Foter from "./components/Foter";
import Privacyinfo from "./components/Privacyinfo";

function App() {
  return (
    <Router> {/* २. Router ने पूर्ण कोड वेढून टाका */}
      <div className="App">
        <NavBar />
        
        <Routes> {/* ३. Routes सुरु करा */}
          <Route path="/" element={
            <>
              <div id="home"><HeroSection /></div>
              <div id="about"><About /></div>
              <div id="services"><Services /></div>
              <div id="music"><Song /></div>
              <div id="products"><Pooja /></div>
              <div id="contact"><Contact /></div>
            </>
          } />

          {/* ४. हा नवीन मार्ग जोडा */}
          <Route path="/privacy-policy" element={<Privacyinfo />} />
        </Routes>

        <Foter />
      </div>
    </Router>
  );
}

export default App;